import { IconAlertCircle } from '@developerz/ui';
import type { JSX } from 'solid-js';

// The personal-only refusal (epic #3629, child #3632): `validOrgKey` needs
// `user_id IS NULL`, so an account holding only personal keys has ZERO usable
// keys — the funnel's key step never completes and no scout can run — and
// until now neither keys surface said so. Presenter; the verdict is
// `useOrgKeyGate` (`lib/org-key-gate.ts`) and the sentence is the caller's, because
// the funnel card and the org keys page each name what "this step" means.
//
// `role="status"`, not `alert`: it is a standing condition the page re-reads
// on every poll, not an event, and an assertive announcement on every refetch
// would talk over the reader.

export function OrgKeyGateNotice(props: { readonly message: string }): JSX.Element {
  return (
    <div class="alert alert--icon alert--destructive org-key-gate" role="status">
      <IconAlertCircle />
      <p class="alert__title">{props.message}</p>
    </div>
  );
}
